import { ListItem, ListItemIcon, ListItemText } from "@material-ui/core";
import { AddShoppingCart } from "@material-ui/icons";
import BusinessIcon from "@material-ui/icons/Business";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { checkRequiredPermissions, USER_GROUPS } from "../../../Utils/Common";
import { showSidebar } from "../../../redux/actions/sidebarActions";
import CollapseGroup from "../CollapseGroup";

/**
 * ContactsModule
 * DeviceModule
 * MaintenanceModule
 * SoftwareModule
 * SystemModule
 */
export default function SoftwareModule() {
  const { t } = useTranslation();
  const history = useHistory();
  const dispatch = useDispatch();

  // Allowed Uswer groups
  return checkRequiredPermissions([USER_GROUPS.ADMIN]) ? (
    <CollapseGroup
      mainItemAction={() => {
        history.push("/cpanel/resupply");
        dispatch(showSidebar(false));
      }}
      mainItemIcon={<AddShoppingCart />}
      header={t("resupplyOrders.header")}
    >
      <ListItem
        button
        onClick={() => {
          history.push("/cpanel/resupply/suppliers");
          dispatch(showSidebar(false));
        }}
      >
        <ListItemIcon>
          <BusinessIcon />
        </ListItemIcon>
        <ListItemText primary={t("resupplyOrders.supplierCompanies")} />
      </ListItem>
    </CollapseGroup>
  ) : null;
}
